import React from 'react'
import { Row, Col, Input, Switch } from 'antd'
import { useTranslation } from 'react-i18next'

interface Props {
  parentState: any
  setParentState: any
}

const ComponentButton = (props: Props): JSX.Element => {
  const { t } = useTranslation()
  const { parentState, setParentState } = props

  return (
    <Col span={24}>
      <Row gutter={[0, 2]}>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={6}>
              <label>
                {t('ficheComparative.componentButton.labels.hidden')}
              </label>
            </Col>
            <Col span={18}>
              <Switch
                checked={parentState?.button?.hidden || false}
                onChange={checked => {
                  const newParentState = {
                    ...parentState,
                    button: {
                      ...parentState.button,
                      hidden: checked,
                    },
                  }
                  setParentState(newParentState)
                }}
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              <label>
                {t('ficheComparative.componentButton.labels.label')}
              </label>
            </Col>
            <Col span={24}>
              <Input
                placeholder={t(
                  'ficheComparative.componentButton.placeholders.label'
                )}
                defaultValue={parentState.button?.label || ''}
                disabled={parentState.button?.hidden || false}
                onBlur={e => {
                  const newParentState = {
                    ...parentState,
                    button: {
                      ...parentState.button,
                      label: e.target.value,
                    },
                  }
                  // newParentState.button.label = e.target.value
                  setParentState(newParentState)
                }}
              />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              <label>{t('ficheComparative.componentButton.labels.url')}</label>
            </Col>
            <Col span={24}>
              <Input
                placeholder={t(
                  'ficheComparative.componentButton.placeholders.url'
                )}
                defaultValue={parentState.button?.url || ''}
                disabled={parentState.button?.hidden || false}
                onBlur={e => {
                  const newParentState = {
                    ...parentState,
                    button: {
                      ...parentState.button,
                      url: e.target.value,
                    },
                  }
                  setParentState(newParentState)
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Col>
  )
}

export default ComponentButton
